import { apiClient } from '@/lib/apiClient';

export interface UserPreferences {
  'Nexo.User.Theme': string;
  'Nexo.User.Language': string;
  'Nexo.User.FormatLocale': string;
  'Nexo.User.AccentColor': string;
  'Nexo.User.LandingPage': string;
  'Nexo.User.EmailNotifications': string;
}

export const USER_PREF_KEYS = {
  theme: 'Nexo.User.Theme',
  language: 'Nexo.User.Language',
  formatLocale: 'Nexo.User.FormatLocale',
  accentColor: 'Nexo.User.AccentColor',
  landingPage: 'Nexo.User.LandingPage',
  emailNotifications: 'Nexo.User.EmailNotifications',
} as const;

const BASE_PATH = '/api/user-preferences';

export const userPreferencesService = {
  async get(): Promise<UserPreferences> {
    const { data } = await apiClient.get<UserPreferences>(BASE_PATH);
    return data;
  },

  async update(settings: Partial<Record<string, string>>): Promise<void> {
    await apiClient.put(BASE_PATH, settings);
  },
};
